// @noflow
import { Container, CurrentTimeBorder, CurrentTimeContainer, CurrentTimeLabel, Label } from './style';
import { MIN_WIDTH, SIDE_MARGIN_WIDTH } from '../constants';
import React, { Component } from 'react';

import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { rangeStep } from 'lodash/fp';

const _getLabelFormat = value =>
    moment
        .utc(0)
        .hours(value)
        .format('LT')
        .replace(':00', '')
        .replace(' ', '')
        .toLowerCase();

export default class TimeAxis extends Component {
    static propTypes = {
        currentTime: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        isSliderShown: PropTypes.bool.isRequired,
        top: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired
    };

    shouldComponentUpdate(nextProps) {
        const { currentTime, height, isSliderShown, top, width } = this.props;

        return (
            height !== nextProps.height ||
            isSliderShown !== nextProps.isSliderShown ||
            top !== nextProps.top ||
            width !== nextProps.width ||
            currentTime !== nextProps.currentTime
        );
    }

    render() {
        const { currentTime, height, isSliderShown, top, width } = this.props;

        const axisWidth = width - 2 * SIDE_MARGIN_WIDTH;
        const y = top + height / 2;
        // define the frequency of the labels depending of the width od the schedule
        const step = {
            [true]: 6,
            [width > 2 * MIN_WIDTH]: 4,
            [width > 3 * MIN_WIDTH]: 3,
            [width > 4 * MIN_WIDTH]: 2,
            [width > 6 * MIN_WIDTH]: 1
        }[true];
        const labels = rangeStep(step, 0, 25).map((hour, i) => (
            <Label dy="4" key={`axis-label-${hour}`} x={SIDE_MARGIN_WIDTH + hour * axisWidth / 24} y={y}>
                {_getLabelFormat(hour)}
            </Label>
        ));

        const currentTimeX = SIDE_MARGIN_WIDTH + currentTime * axisWidth / 1440;
        const currentTimeSize = height * 3 / 4;

        return (
            <Container fade={isSliderShown}>
                {labels}
                <CurrentTimeContainer
                    style={{
                        transform: `translate3d(${currentTimeX}px, ${y}px, 0)`
                    }}
                    transform={`translate(${currentTimeX} ${y})`}
                >
                    <CurrentTimeBorder
                        height={currentTimeSize}
                        rx={currentTimeSize / 2}
                        ry={currentTimeSize / 2}
                        width={currentTimeSize * 2}
                        x={-currentTimeSize}
                        y={-currentTimeSize / 2}
                    />
                    <CurrentTimeLabel dy="4">
                        {moment
                            .utc(0)
                            .minutes(currentTime)
                            .format('LT')
                            .replace(' ', '')
                            .toLowerCase()}
                    </CurrentTimeLabel>
                </CurrentTimeContainer>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/time-axis/component.js